<a
  class="product-card product-card--listing"
  [routerLink]="data()._id ? '/projects/' + data()._id : ''">
  <div class="product-card__listing-media">
    <img
      class="product-card__listing-image"
      [ngSrc]="coverImage() | imageSource"
      [width]="400"
      [height]="300"
      [alt]="(data().title | translateData) || ''" />

    @if (data().code != null) {
      <div class="product-card__listing-code">
        {{ data().code }}
      </div>
    }
  </div>

  <div class="product-card__listing-info">
    <div class="product-card__listing-text">
      <h3 class="product-card__listing-title">
        {{ data().title | translateData }}
      </h3>
      @if (subtitle(); as sub) {
        <p class="product-card__listing-subtitle">
          {{ sub | translateData }}
        </p>
      } @else if (data().status != null) {
        <p class="product-card__listing-subtitle">
          {{ 'enums.projectStatus.' + data().status | translate }}
        </p>
      }
    </div>
  </div>

  @if (data().description != null && (data().description | translateData); as desc) {
    @if (desc && desc !== '-') {
      <div class="product-card__listing-footer project-card__listing-footer">
        <p class="project-card__listing-description">
          <pwj-text-summarizer
            [limitLength]="96"
            [truncate]="true"
            [text]="desc" />
        </p>
      </div>
    }
  }
</a>
